

























import { Component, Prop, Vue } from 'vue-property-decorator';
import Surface from '@/components/atoms/Surface/Surface.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';

@Component({ components: { Surface, Picture, Typography } })
export default class UserIcon extends Vue {
  @Prop({ default: '' }) readonly src?: string;
  @Prop({ default: '20px' }) readonly borderRadius?: string;
}
